import React from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import PSIcon from '../../components/PSIcon';
import { pathServer } from '../../../util/Constant';

import './index.scss';

export default function BeneficiariesPage() {
  const history = useHistory();
  const location = useLocation();
  const policyDetail = JSON.parse(localStorage.getItem('policyDetail')) || null;

  const formatDate = (fecha) => {
    if (!fecha) return '';
    return fecha.split(' ')[0];
  };

  const goToPageProduct = () => {
    history.push({
      pathname: '/intranet/product/vidaInversion',
      state: location.state,
    });
  };

  const goToPagePolicy = () => {
    window.history.back();
  };

  return (
    <div className="table-beneficiaries">
      <div className="table-beneficiaries__breadcrumb">
        <Link to="/intranet" className="breadcrumb-link">
          <PSIcon type="homeGray" className="breadcrumb-icon" />
          <span>Mis seguros</span>
        </Link>
        <div className="breadcrumb-separator">
          <PSIcon type="arrowRightOrange" className="arrow" />
        </div>
        <div className="breadcrumb-link" onClick={() => goToPageProduct()}>
          <span>Vida Inversión Global Protecta</span>
        </div>
        <div className="breadcrumb-separator">
          <PSIcon type="arrowRightOrange" className="arrow" />
        </div>
        <div className="breadcrumb-link" onClick={() => goToPagePolicy()}>
          <span>Ver más</span>
        </div>
        <div className="breadcrumb-separator">
          <PSIcon type="arrowRightOrange" className="arrow" />
        </div>
        <span className="breadcrumb-current">Beneficiarios</span>
      </div>
      <div
        className="table-beneficiaries__title"
        onClick={goToPagePolicy}
        style={{ cursor: 'pointer' }}
      >
        <img src={`${pathServer.PATH_ICONS}arrow-left-big.svg`} width="8px" />
        <h2>Beneficiarios</h2>
      </div>
      <table className="table-beneficiaries__container">
        <thead className="table-beneficiaries__container--header">
          <tr>
            <th className="font-semibold">Nombres</th>
            <th className="font-semibold">Documento</th>
            <th className="font-semibold">Participación</th>
            <th className="font-semibold">Fecha de registro</th>
          </tr>
        </thead>
        <tbody className="table-beneficiaries__container--body">
          {policyDetail?.Beneficiarios.map((row) => (
            <tr key={row.Documento} className="beneficiary-item">
              <td>{row.Nombre}</td>
              <td>{row.Documento}</td>
              <td>{row.Participacion}%</td>
              <td>{formatDate(row.FechaReg)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
